<template>
  <section class="screen race-select">
    <header class="sub">
      <h1>Choose Race</h1>
      <input v-model="query" type="search" placeholder="Filter events or races">
    </header>

    <div v-if="raceEvents.length < 1" class="empty-state">
      No race events loaded.
    </div>

    <section v-for="raceEvent in filteredRaceEvents" :key="raceEvent.id" class="event-section">
      <h2>{{ raceEvent.name }}</h2>
      <div class="race-grid">
        <router-link
          v-for="race in racesFor(raceEvent)"
          :key="race.id"
          class="race-button"
          :to="{ name: 'registration', params: { raceEventId: raceEvent.id, raceId: race.id } }"
        >
          <i :style="{ backgroundColor: race.color || '#777' }" />
          <span class="name">{{ race.name }}</span>
          <span class="time">{{ race.startTime ? $fmt.daytime(race.startTime) : 'No start' }}</span>
        </router-link>
      </div>
    </section>
  </section>
</template>

<style lang="scss">
.race-select {
  header.sub {
    justify-content: space-between;
    gap: 1rem;

    input {
      max-width: 420px;
      width: 45vw;
      min-width: 220px;
      font-size: 1.1rem;
    }
  }

  .event-section {
    margin-top: 1.5rem;

    h2 {
      margin: 0 0 0.75rem;
      font-size: 1.15rem;
      font-weight: 400;
      color: var(--text-dim1-color);
    }
  }

  .race-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
    gap: 0.75rem;
  }

  .race-button {
    display: grid;
    grid-template-columns: 16px 1fr auto;
    align-items: center;
    gap: 0.7rem;
    min-height: 58px;
    padding: 0.75rem 1rem;
    border-radius: var(--br-sharp);
    color: var(--text-color);
    text-decoration: none;
    background: var(--button-bgcolor);
    box-shadow: var(--button-shadow);

    i {
      width: 14px;
      height: 14px;
      border-radius: 50%;
    }

    .name {
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 1.15rem;
    }

    .time {
      color: var(--text-dim1-color);
      white-space: nowrap;
    }
  }
}
</style>

<script>
export default {
  props: {
    raceEventId: {
      type: [String, Number],
      default: null,
    },
  },

  data() {
    return {
      query: '',
    }
  },

  computed: {
    raceEvents() {
      return Object.values(this.sharedStore.state.raceEvent)
        .sort((a, b) => String(a.name).localeCompare(String(b.name)))
    },

    filteredRaceEvents() {
      const q = this.query.trim().toLowerCase()
      const events = this.raceEventId ?
        this.raceEvents.filter(re => String(re.id) === String(this.raceEventId)) :
        this.raceEvents

      if (!q) return events

      return events.filter(re => {
        if (String(re.name || '').toLowerCase().includes(q)) return true
        return this.racesFor(re).some(race => String(race.name || '').toLowerCase().includes(q))
      })
    },
  },

  mounted() {
    if (this.raceEventId) this.sharedStore.setActiveRaceEvent(this.raceEventId)
  },

  methods: {
    racesFor(raceEvent) {
      return (raceEvent.races || [])
        .filter(Boolean)
        .sort((a, b) => {
          const at = a.startTime ? a.startTime.getTime() : 0
          const bt = b.startTime ? b.startTime.getTime() : 0
          return at - bt || String(a.name).localeCompare(String(b.name))
        })
    },
  },
}
</script>
